import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import ArrowBack from '@mui/icons-material/ArrowBack';
import PageHeader from '../../../Components/PageHeader';
import { useApiGet } from '../../../utils/httpClientTs';
import { getItem } from '../../../endpoints/chapterSupplies';

export default function ItemDetail() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const { data: item, isFetching } = useApiGet(
    ['chapter-supplies-item', id],
    () => getItem(id!),
    { enabled: !!id, retry: 1 }
  );

  if (!id) {
    return (
      <Grid container paddingLeft={2} paddingRight={2}>
        <Typography>Invalid item ID.</Typography>
      </Grid>
    );
  }

  return (
    <Grid container paddingLeft={2} paddingRight={2}>
      <Grid item xs={12}>
        <PageHeader
          title={item?.name ?? 'Item'}
          leftDom={
            <Button
              startIcon={<ArrowBack />}
              onClick={() => navigate('/chapter-supplies-management/items')}
            >
              Back to list
            </Button>
          }
          rightDom={undefined}
          subtitle={undefined}
        />
      </Grid>
      {isFetching && (
        <Grid item xs={12}>
          <Typography>Loading…</Typography>
        </Grid>
      )}
      {!isFetching && item && (
        <Grid item xs={12} sx={{ mt: 2 }}>
          <Typography variant="body1">
            <strong>Status:</strong>{' '}
            {item.item_status_name ?? item.item_status_id}
          </Typography>
          {item.sku && (
            <Typography variant="body1">
              <strong>SKU:</strong> {item.sku}
            </Typography>
          )}
          {item.description && (
            <Typography variant="body1">
              <strong>Description:</strong> {item.description}
            </Typography>
          )}
          {item.quantity_on_hand != null && (
            <Typography variant="body1">
              <strong>Quantity on hand:</strong> {item.quantity_on_hand}
            </Typography>
          )}
        </Grid>
      )}
    </Grid>
  );
}
